/**
 * The `/admin/ai-apis/*` route table (A7Y-5559), declared here rather than
 * inline in `App.tsx` so `aiApisRoutes.test.tsx` can run react-router's own
 * matcher over the real array, as `autobuild/automationRoutes.tsx` does.
 * Rendered as `{aiApisRoutes}` inside the `/admin` layout route.
 */
import { Navigate, Route } from 'react-router-dom';
import OverviewPage from './OverviewPage';
import ProviderDetailPage from './ProviderDetailPage';
import ModelsPage from './ModelsPage';
import TasksPage from './TasksPage';

export const aiApisRoutes = [
  <Route
    key="ai-apis"
    path="ai-apis"
    element={<Navigate to="/admin/ai-apis/overview" replace />}
  />,
  <Route key="ai-apis-overview" path="ai-apis/overview" element={<OverviewPage />} />,
  <Route
    key="ai-apis-provider"
    path="ai-apis/providers/:provider"
    element={<ProviderDetailPage />}
  />,
  <Route key="ai-apis-models" path="ai-apis/models" element={<ModelsPage />} />,
  <Route key="ai-apis-tasks" path="ai-apis/tasks" element={<TasksPage />} />,
];
